import { FC } from "react";

export const CVXIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
        fill="white"
      />
      <path
        d="M23.7622 12.979V8.9396H21.7395V6.91233H17.6955V4.89111H13.6516V6.91233H9.60915V8.9396H7.58643V21.0608H9.60764V23.0835H13.6516V25.1047H17.694V23.0881H21.7395V21.0608H23.7622V17.0214H19.7182V19.0441H17.6955V21.0608H13.6516V19.0441H11.6304V10.9563H13.6516V8.9396H17.6955V10.9563H19.7182V12.979H23.7622Z"
        fill="#3A3A3A"
      />
      <path
        d="M19.7182 10.9575H18.3698V12.9787H19.7182V10.9575Z"
        fill="#1682FE"
      />
      <path
        d="M17.6955 8.93506H16.347V10.9563H17.6955V8.93506Z"
        fill="#1682FE"
      />
      <path
        d="M13.6529 4.89111H12.3044V6.91233H13.6529V4.89111Z"
        fill="#1682FE"
      />
      <path
        d="M19.7167 17.0229H17.697V19.0457H19.7167V17.0229Z"
        fill="#FF5A5A"
      />
      <path
        d="M17.697 19.0439H16.3485V21.0652H17.697V19.0439Z"
        fill="#FF5A5A"
      />
      <path
        d="M13.6515 23.0879H12.303V25.1091H13.6515V23.0879Z"
        fill="#FF5A5A"
      />
      <path
        d="M9.60764 21.0649H8.25916V23.0862H9.60764V21.0649Z"
        fill="#F4BB3B"
      />
      <path d="M7.5864 15H6.23792V21.0652H7.5864V15Z" fill="#F4BB3B" />
      <path
        d="M7.5864 8.93506H6.23792V15.0002H7.5864V8.93506Z"
        fill="#60D8A4"
      />
      <path
        d="M9.6091 6.91357H8.26062V8.93479H9.6091V6.91357Z"
        fill="#1682FE"
      />
    </svg>
  );
};
